import * as types from "./types";

const mutations = {
    [types.POST_BANKSTATEMENT](state, bankStatement) {
        state.bankStatement = bankStatement;
      },
    [types.GET_BANKSTATEMENT](state, bankStatement) {
        state.bankStatement = bankStatement;
    },
    [types.GET_BANKSTATEMENT_BY_ID](state, bankStatement) {
        state.bankStatement = bankStatement;
    },
    [types.UPDATE_BANKSTATEMENT](state, bankStatement) {
        state.bankStatement = bankStatement;
    },
};

export default mutations;